import "./PreListingInspection.module.css";
import Header from "@/reusable_sections/Header";
import HeroIntroduction from "./sections/HeroIntroduction";
import MosJourneyBrandOrigin from "./sections/MosJourneyBrandOrigin";
import OwnershipBenefits from "./sections/OwnershipBenefits";
import OrderDirectly from "./sections/OrderDirectly";
import Footer from "@/reusable_sections/Footer";
export default function PreListingInspectionPage() {
  return <div>
      <Header />
      <HeroIntroduction />
      <MosJourneyBrandOrigin />
      <OwnershipBenefits />
      <OrderDirectly />
      <Footer />
    </div>;
}